import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class RoundQuestionFormService {
  constructor() {}

  public removeFormControls(controlName: string, formGroup: UntypedFormGroup): void {
    if (formGroup.get(controlName)) {
      formGroup.removeControl(controlName);
    }
  }
}
